<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{titles.packsInfo}}</h4>
                <form @keyup.enter="onSubmit" class="text-left">
                    <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                    <div :class="{'disabledInput': $route.path.includes('update')||(this.idSelectedPack != null && $route.path.includes('validateUser'))}" class="px-4"
                         style="margin-left: -4.5%"
                         v-if="!isEditable">
                        <div class="row">
                            <div :class="{'disabledInput': (this.idSelectedPack != 'undefined' && $route.path.includes('organisation/add'))}" class="col-lg-12">
                                <label class="selectDomainRequired"
                                       v-if="$route.path.includes('organisation')
                                           && form.packCountryDomain && form.packCountryDomain.domain.id == null">
                                    {{titles.pleaseSelectCountryDomain}}</label>
                                <DropDownVue :icon="icons.typePack"
                                             :items="packs"
                                             :label="titles.typePack"
                                             :validate="$v.formComponent.typePack.id"
                                             @method="handleChangeDropDown"
                                             inputKey="typePack"
                                             itemKey="id"
                                             itemValue="label"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="px-4 functionality-header" v-if="showFunctionalies">
                        <div class="row">
                            <PackTypePack
                                    class="align-center"
                                    :country="this.formComponent.country"
                                    :domain="this.formComponent.domain"
                                    :key="this.formComponent.id"
                                    :packCountryDomain="this.formComponent"
                            />
                           <!-- <FunctionalitiesPack :data="items"/>-->
                        </div>
                    </div>
                    <div class="px-4" v-if="isEditable">
                        <div class="row">
                            <div class="col-lg-4">
                                <CheckBox :inputKey="'isFree'" :name="titles.isFree" :validate="isFreePack"
                                          @method="getValue"/>
                            </div>
                            <div class="col-lg-4">
                                <CheckBox :inputKey="'isUnlimited'" :name="titles.isUnlimited"
                                          :validate="isUnlimitedPack"
                                          @method="getValue" v-if="isFreePack == true"/>
                            </div>

                            <div class="col-lg-4">
                                <CheckBox
                                        :inputKey="'isLight'" :name="titles.light" :validate="isLight"
                                        @method="getValue"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="isEditable">
                        <div class="px-4">
                            <div class="row">
                                <div class="col-lg-6"
                                     v-if="(isEditable&&!formComponent.isFree) || !formComponent.isFree">
                                    <Input :decimalDigits="decimalDigits"
                                           :disabled="!isEditable"
                                           :icon="icons.pricePack"
                                           :inputKey="'price'"
                                           :name="pricePack"
                                           :validate="$v.formComponent.price"
                                           @method="getValue"
                                    />
                                </div>
                                <div class="col-lg-6" v-if="!isEditable && formComponent.isFree">
                                    <Input :disabled="!isEditable"
                                           :forcedVal="titles.free"
                                           :icon="icons.pricePack"
                                           :name="pricePack"
                                    />
                                </div>
                                <div class="col-lg-6" v-if="(!isUnlimitedPack&&isFreePack)||!isFreePack">
                                    <Input :disabled="!isEditable"
                                           :icon="icons.trialPeriod"
                                           :inputKey="'freePeriod'"
                                           :name="titles.trialPeriod"
                                           :validate="$v.formComponent.freePeriod"
                                           @method="getValue"
                                           type="number"
                                           v-if="isEditable || formComponent.freePeriod != -1"
                                    />
                                    <Input :disabled="!isEditable"
                                           :forcedVal="titles.unlimited"
                                           :icon="icons.trialPeriod"
                                           :name="titles.trialPeriod"
                                           v-if="!isEditable && formComponent.freePeriod == -1"
                                    />
                                </div>
                                <div class="col-lg-6">
                                    <Input :disabled="!isEditable"
                                           :icon="icons.numberOfHoursOfSupport"
                                           :inputKey="'technicalSupport'"
                                           :name="titles.numberOfHoursOfSupport"
                                           :validate="$v.formComponent.technicalSupport"
                                           @method="getValue"
                                           type="number"
                                    />
                                </div>
                                <div class="col-lg-6">
                                    <Input :disabled="!isEditable"
                                           :icon="icons.numberOfUsers"
                                           :inputKey="'numberOfUsers'"
                                           :name="titles.numberOfUsers"
                                           :validate="$v.formComponent.numberOfUsers"
                                           @method="getValue"
                                           type="number"/>
                                </div>
                                <div class="col-lg-6" v-if="!formComponent.isFree">
                                    <Input :disabled="!isEditable"
                                           :icon="icons.subscriptionPeriod"
                                           :inputKey="'subscriptionPeriod'"
                                           :name="titles.subscriptionPeriod"
                                           :validate="$v.formComponent.subscriptionPeriod"
                                           @method="getValue"
                                           type="number"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-4">
                        <div class="row">
                            <div class="col-md-12">
                                <button
                                        :disabled="isLoading"
                                        @click="previousTab"
                                        class="btn btn-standard-gradient px-5"
                                        style="float: left"
                                        type="button"
                                        v-if="(($route.path.includes('organisation/add') || $route.path.includes('client/add')) && !isEditable) || (formName == 'validateUser')"
                                >
                                    {{previous_btn}}
                                </button>
                                <button
                                        :disabled="isLoading"
                                        @click="onSubmit"
                                        class="btn btn-standard-gradient px-5"
                                        style="float: right"
                                        type="button"
                                        v-if="!$route.path.includes('organisation/update')"
                                >
                                    <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                                    {{name_btn}}
                                </button>
                                <modal-success :title="titles.addOrganisationMessage"
                                               @messageFromModal="closeModal"
                                               id="success-organisation"/>
                                <modal-success :title="titles.addClientMessage"
                                               @messageFromModal="closeModal"
                                               id="success-client"/>
                                <modal-error
                                        :title="titles.cannotAddOperationMessage"
                                        id="cannot-add-operation"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <modal-error :title="errorMsg" id="error-delete-client"/>
        <modal-success :title="titles.updatePackCountryDomain" id="success-pack-country-domain"/>
    </div>
</template>

<script>
    import {addOrganisation} from '../services/organisations.service';
    import {
        addClient,
        validateUser
    } from '../services/user.service';
    import ModalSuccess from '../../common/modal-success';
    import CheckBox from '@/components/common/CheckBox.vue';
    import {
        minValue,
        required
    } from 'vuelidate/lib/validators';
    import {titles} from '../../../utils/general/titles';
    import {roles} from '../../../utils/general/roles';
    import {typePack} from '../models/typePack';
    import {packCountryDomain} from '../models/packCountryDomain';
    import Input from '@/components/common/Input.vue';
    import {icons} from '../../../utils/general/icons';
    import DropDownVue from '../../common/DropDownVue';
    import numeric from 'vuelidate/lib/validators/numeric';
    import {
        addPackCountryDomain,
        getPackCountryDomain,
        updatePackCountryDomain
    } from '../services/packCountryDomain.service';
    import decimal from 'vuelidate/lib/validators/decimal';
    import ModalError from '../../common/modal-error';
    import {getFunctionalitiesAndModuleByPack} from '../services/packCountryDomainFunctionality.service';
  //  import FunctionalitiesPack from './FunctionalitiesPack';
    import PackTypePack from './PackTypePack';
    import $ from 'jquery';
    import {errorMixin} from '../../../utils/errorMixin';

    export default {
        name: 'PackInfo',
        props: {
            form: Object,
            role: String,
            packCountryDomain: Array,
            codePromo: Boolean
        },
        components: {PackTypePack, /*FunctionalitiesPack,*/ ModalSuccess, Input, DropDownVue, CheckBox, ModalError},
        data() {
            return {
                titles,
                roles,
                icons,
                isLoading: false,
                errorMsg: '',
                packs: [],
                isEditable: this.$route.path.includes('pack'),
                name_btn: this.$route.path.includes('add') ? titles.add :
                    this.$route.path.includes('validateUser') ? titles.activateCompte : titles.update,
                previous_btn: titles.previous,
                formComponent: this.form && this.form.packCountryDomain ? this.form.packCountryDomain : packCountryDomain(),
                formName: this.$route.path.includes('organisation') ? 'organisation' :
                    this.$route.path.includes('validateUser') ? 'validateUser' : 'client',
                isFreePack: false,
                isUnlimitedPack: false,
                selectedElement: null,
                selectedElementKeys: null,
                packsToAdd: [],
                voucher: this.codePromo,
                pricePack: titles.pricePack,
                decimalDigits: 0,
                minFreePeriod: 0,
                modules: [],
                items: [],
                showFunctionalies: false,
                idSelectedPack: 0,
                isLight: false,
            };
        },
        created() {
            this.idSelectedPack = JSON.parse(localStorage.getItem("typePack"));
            if ((this.$route.path.includes('update') || this.$route.path.includes('validateUser')) && this.formComponent.domain.id != null
                && this.form.organisation.client.country.id != null) {
                if(this.$route.path.includes('update')){
                    getPackCountryDomain(this.formComponent.domain.name,
                        this.form.organisation.client.country.code, 'BackOffice', true).then(response => {
                        this.packs = Object.values(response.data['hydra:member'])[0].map(pack => typePack(pack.typePack));
                    });
                }
                const id = this.formComponent['@id'].split('/').slice(-1)[0];
                this.getFunctionaliesBy(id);
            }
            if (this.isEditable) {
                this.formName = '';
                if (this.$cookies.isKey('pack')) {
                    this.formComponent = this.$cookies.get('pack');
                    this.formComponent.isUnlimited = this.formComponent.freePeriod == -1;
                    this.isUnlimitedPack = this.formComponent.isUnlimited;
                    if (this.formComponent.isUnlimited == true) {
                        this.formComponent.freePeriod = this.$v.formComponent.freePeriod.$params.minValue.min;
                    }
                    if (this.formComponent.isFree == true) {
                        this.formComponent.price = this.$v.formComponent.price.$params.minValue.min;
                        this.formComponent.subscriptionPeriod = this.$v.formComponent.subscriptionPeriod.$params.minValue.min;
                    }
                    this.isFreePack = this.formComponent.isFree;
                    this.isLight = this.formComponent.isLight;
                    if (!this.formComponent.id) {
                        this.name_btn = this.titles.next;
                        this.$emit('goToFunctionality', false);
                    }
                } else {
                    this.$router.push(this.$cookies.get('fromPath'));
                }
            } else {
                if (this.$route.params.idSelectedPack != undefined) {
                    this.idSelectedPack = this.$route.params.idSelectedPack;
                } else if (this.$cookies.get('user') && this.$cookies.get('user').idSelectedPack != null) {
                    this.idSelectedPack = this.$cookies.get('user').idSelectedPack;
                }
                this.getPacks();
                if(this.formComponent.id != null){
                    this.getFunctionaliesBy(this.formComponent.id);
                }
            }
            if ((localStorage.getItem("connected_typePack")) != undefined &&
                this.$route.path.includes('organisation/add')) {
                this.idSelectedPack = (localStorage.getItem("connected_typePack")) ;
            }
            this.pricePack += ' (' + this.formComponent.country.currency + ')';
            this.decimalDigits = this.formComponent.country.decimalDigits;
           /* if(this.fomCromponent.id == undefined){
                this.fomCromponent = packCountryDomain(this.packCountryDomain[0].find(element => element.typePack.id == this.idSelectedPack));
            }*/
        },
        mixins: [errorMixin],
        methods: {
            getFunctionaliesBy(id) {
                this.showFunctionalies = true;
                this.items = [];
                getFunctionalitiesAndModuleByPack(id).then(response => {
                    this.items = response.data;
                    setTimeout(function () {
                        const val = Math.max($('.pack').height(), 4 * $('.functionalityTitle').height() + $('.list-functionalities').height());
                        $('.packTypePack').height(val);
                      /*  $('.functionalitiesPack').height(val);*/
                    }, 100);
                });
            },
            getPacks() {
                this.packs = this.packCountryDomain[0] ? this.packCountryDomain[0].map(pack => typePack(pack.typePack)) : [];
                if (this.idSelectedPack != 0) {
                    const localPack = this.packs.find(item => item.id == this.idSelectedPack);
                    if (localPack != null) {
                        this.formComponent.typePack = typeof (this.idSelectedPack) == Object ?
                            this.idSelectedPack: localPack;
                       // this.formComponent.typePack = localPack;
                        this.getFunctionaliesBy(this.idSelectedPack);
                    }
                }
                this.formComponent.country = this.packCountryDomain[0][0].country;
                this.formComponent.price = parseFloat(this.formComponent.price).toFixed(this.formComponent.country.decimalDigits);
            },
            previousTab() {
                this.$emit('nextTab', {
                    name: 'Organisation',
                    component: 'OrganisationInfo'
                });
                if (this.formName == 'validateUser') {
                    this.$emit('previous', this.form);
                }
            },
            handleChangeDropDown(val, inputKey) {
                if (inputKey == 'typePack') {
                    if (this.packCountryDomain[0] && val != null) {
                        this.formComponent = packCountryDomain(this.packCountryDomain[0].find(element => element.typePack.id == val.id));

                    }
                    this.form.packCountryDomain.typePack = val;
                    this.formComponent.domain = this.form.packCountryDomain.domain;
                    this.form.packCountryDomain = this.formComponent;
                    this.getFunctionaliesBy(this.formComponent.id);
                    this.formComponent.price = parseFloat(this.formComponent.price).toFixed(this.formComponent.country.decimalDigits);
                    if (this.formComponent.isFree == true) {
                        this.isFreePack = this.formComponent.isFree;
                    } else {
                        this.isFreePack = false;
                    }
                } else {
                    this.formComponent[inputKey] = val;
                }
            },
            getValue(inputKey, val) {
                this.formComponent[inputKey] = val;
                if (this.isEditable) {
                    if (this.formComponent.isFree == true) {
                        this.formComponent.price = this.formComponent.price <= this.$v.formComponent.price.$params.minValue.min ?
                            this.$v.formComponent.price.$params.minValue.min : this.formComponent.price;
                        this.formComponent.subscriptionPeriod = this.formComponent.subscriptionPeriod <= this.$v.formComponent.subscriptionPeriod.$params.minValue.min ?
                            this.$v.formComponent.subscriptionPeriod.$params.minValue.min : this.formComponent.subscriptionPeriod;
                        this.isFreePack = true;
                        if (this.formComponent.isUnlimited == true) {
                            this.formComponent.freePeriod = this.formComponent.freePeriod <= this.$v.formComponent.freePeriod.$params.minValue.min ?
                                this.$v.formComponent.freePeriod.$params.minValue.min : this.formComponent.freePeriod;
                            this.isUnlimitedPack = true;
                        } else {
                            this.minFreePeriod = 1;
                            this.isUnlimitedPack = false;
                        }
                    } else {
                        this.minFreePeriod = 0;
                        this.isUnlimitedPack = false;
                        this.formComponent.isUnlimited = false;
                        this.isFreePack = false;
                    }
                }
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.errorMsg = null;
                this.isLoading = true;

                if (this.isEditable == true) {
                    if (this.formComponent.isFree == true) {
                        this.formComponent.price = 0;
                        this.formComponent.subscriptionPeriod = 0;
                    }
                    if (this.formComponent.isUnlimited == true) {
                        this.formComponent.freePeriod = -1;
                    }
                    const localFormComponent = packCountryDomain(this.formComponent);
                    localFormComponent.domain = this.formComponent.domain.id;
                    localFormComponent.country = this.formComponent.country.id;
                    localFormComponent.typePack = this.formComponent.typePack.id;
                    localFormComponent.price = parseFloat(localFormComponent.price);
                    localFormComponent.freePeriod = parseInt(localFormComponent.freePeriod, 0);
                    localFormComponent.subscriptionPeriod = parseInt(localFormComponent.subscriptionPeriod, 0);
                    const id = localFormComponent.id;
                    delete localFormComponent.id;
                    delete localFormComponent.isUnlimited;
                    if (!id) {
                        addPackCountryDomain(localFormComponent).then(
                            response => {
                                this.$bvModal.show('success-pack-country-domain');
                                this.isLoading = false;
                                this.formComponent.id = response.data.id;
                                this.$cookies.set('pack', this.formComponent);
                                this.$emit('goToFunctionality', true);
                                this.$emit('nextTab', {
                                    name: 'Fonctionnalités',
                                    component: 'FunctionalityInfo'
                                });
                                return response;
                            },
                            error => {
                                this.showError(error);
                            }
                        );
                    } else {
                        updatePackCountryDomain(id, localFormComponent).then(
                            response => {
                                this.isLoading = false;
                                this.$cookies.set('pack', this.formComponent);
                                this.$bvModal.show('success-pack-country-domain');
                                return response;
                            },
                            error => {
                                this.showError(error);
                            }
                        );
                    }
                } else if (this.$route.path.includes('organisation')) {
                    if (this.role == roles.client) {
                        this.form.organisation.client = this.$cookies.get('user').id;
                    } else {
                        this.form.organisation.client = this.form.organisation.client.id;
                    }
                    this.form.price = this.formComponent.price;
                    this.form.decimalDigits = this.formComponent.country.decimalDigits;
                    this.form.currency = this.formComponent.country.currency;
                    this.form.tva = this.formComponent.country.tva.toString();
                    this.form.organisation.country = this.form.organisation.country.id;
                    this.form.organisation.timezone ? this.form.organisation.timezone = this.form.organisation.timezone.text :
                        this.form.organisation.timezone = null;
                    delete this.form.organisation.id;
                    if( (this.formComponent.id) == null){
                        this.formComponent.id = (packCountryDomain(this.packCountryDomain[0].find(element => element.typePack.id == this.idSelectedPack)).id);
                    }
                    addOrganisation(this.form.organisation,
                        this.formComponent.id, this.form.price, this.form.decimalDigits, this.form.currency, false,
                        this.form.tva).then(response => {
                        this.$bvModal.show('success-organisation');
                        this.isLoading = false;
                        return response.data;
                    }, error => {
                        if (error.response.data.message == 'Form Invalid') {
                            this.$bvModal.show('cannot-add-operation');
                            this.isLoading = false;
                        }
                    });
                } else if (this.$route.path.includes('client')) {
                    this.form.packCountryDomain = this.formComponent != undefined && this.formComponent.id ? this.formComponent.id : null;
                    this.form.organisation.client.phoneNumberCode = this.form.organisation.client.phone ? this.form.organisation.client.phoneNumberCode :
                        (this.form.organisation.client.country ? this.form.organisation.client.country.code : 'FR');
                    this.form.organisation.client.country = this.form.organisation.client.country.id ?
                        this.form.organisation.client.country.id : null;
                    this.form.organisation.client.language = this.form.organisation.client.language.id ? this.form.organisation.client.language.id : null;
                    this.voucher = this.voucher ? this.voucher : false;
                    delete this.form.organisation.client.id;
                    delete this.form.organisation.id;
                    this.form.price = this.formComponent.price;
                    this.form.decimalDigits = this.formComponent.country.decimalDigits;
                    this.form.currency = this.formComponent.country.currency;
                    this.form.tva = this.formComponent.country.tva.toString();
                    this.form.organisation.country = this.form.organisation.country.id;
                    if (this.form.organisation.timezone && this.form.organisation.timezone.text != undefined) {
                        this.form.organisation.timezone = this.form.organisation.timezone.text;
                    }
                    const subscription = {
                        'organisation': this.form.organisation,
                        'currency': this.form.currency,
                        'decimalDigits': this.form.decimalDigits,
                        'isPayed': false,
                        'price': this.form.price,
                        'tva': this.form.tva,
                        'packCountryDomain': this.form.packCountryDomain
                    };
                    addClient(subscription, this.voucher)
                        .then(response => {
                                this.$bvModal.show('success-client');
                                this.isLoading = false;
                                return response.data;
                            },
                            error => {
                                if (error.response.data.message === 'Form Invalid') {
                                    this.$bvModal.show('cannot-add-operation');
                                    this.isLoading = false;
                                } else {
                                    this.errorMsg = error.response.data.message;
                                    this.$bvModal.show('error-delete-client');
                                    this.isLoading = false;
                                }

                            });
                } else if (this.formName === 'validateUser') {
                    this.form.packCountryDomain = this.formComponent;
                    this.form.price = this.formComponent.price;
                    this.form.decimalDigits = this.formComponent.country.decimalDigits;
                    this.form.currency = this.formComponent.country.currency;
                    this.form.tva = this.formComponent.country.tva.toString();
                    validateUser(this.form,
                        this.$route.params.idSelectedDomain ? parseInt(this.$route.params.idSelectedDomain, 0) : null,
                        this.$route.params.idSelectedPack ? parseInt(this.$route.params.idSelectedPack, 0) : null
                    ).then(
                        response => {
                            this.$store.dispatch('handle', response);
                            this.isLoading = false;
                        },
                        error => {
                            this.showError400(error);
                        }
                    );
                }

            },
            closeModal() {
                if (this.$route.path.includes('organisation')) {
                    this.$router.push({name: 'organisation'});
                } else {
                    this.$router.push({name: 'network'});
                }
            }
        },
        validations() {
            if (this.formName === 'organisation' || this.formName === 'validateUser' || this.formName === 'client') {
                return {
                    formComponent: {
                        id: {},
                        typePack: {
                            required,
                            id: {required}
                        },
                        price: {},
                        subscriptionPeriod: {},
                        freePeriod: {},
                        technicalSupport: {},
                        numberOfUsers: {}
                    }
                };
            } else {
                return {
                    formComponent: {
                        id: {},
                        typePack: {
                            required,
                            id: {}
                        },
                        price: {
                            required,
                            decimal,
                            checkDecimalNumber(price) {
                                if (this.decimalDigits > 0) {
                                    const regex = new RegExp(`^[0-9]+(\\.[0-9]{1,${this.decimalDigits}})?$`, 'g');
                                    return (regex.test(price));
                                } else {
                                    return true;
                                }
                            },
                            minValue: minValue(0)
                        },
                        subscriptionPeriod: {required, numeric, minValue: minValue(0)},
                        freePeriod: {required, numeric, minValue: minValue(this.minFreePeriod)},
                        technicalSupport: {required, numeric},
                        numberOfUsers: {required, numeric, minValue: minValue(0)},
                        isLight: {  required }
                    }
                };
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/base.css';
</style>
